import { TablePagination } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import VspPortalContext from "../../../store/VspPortalContext";
import { VspPortalActions } from "../../../store/VspPortalActions";

type CardSwapSearchResultsPaginationProps = {
    
    totalCount : number;

};


export const CardSwapSearchResultsPagination : React.FC< CardSwapSearchResultsPaginationProps > = ( props : CardSwapSearchResultsPaginationProps ) => {

    const { totalCount } = props;

    const [ pageNumber, setPageNumber ] = useState< number >( 0 );
    const [ pageSize, setPageSize ] = useState( 20 );
  
    const { dispatch, state } = useContext( VspPortalContext );

    useEffect( ( ) => {

        setPageNumber( state.cardSwapSearchResultPageNumber );
        setPageSize( state.cardSwapSearchResultPageSize );

    }, [ ]);
    

    const handleChangePage = ( newPageNumber: number ): void => {

        setPageNumber( newPageNumber );
        dispatch({ type: VspPortalActions.SetCardSwapSearchResultPageNumber, payload: newPageNumber });
        
    };
  

    const handleChangePageSize = ( event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement> ): void => {
   
        const newPageSize = +event.target.value; 
        setPageSize( newPageSize );
        setPageNumber( 0 );
        dispatch({ type: VspPortalActions.SetCardSwapSearchResultPageSize, payload: newPageSize });
        dispatch({ type: VspPortalActions.SetCardSwapSearchResultPageNumber, payload: 0 });

    };
   
    
    return(

        <TablePagination
            component="div"
            count={ totalCount }
            page={ pageNumber }
            onPageChange={ ( _, newPageNumber ) => handleChangePage( newPageNumber ) }
            rowsPerPage={ pageSize }
            onRowsPerPageChange={ handleChangePageSize }
            rowsPerPageOptions={ [ 20, 50, 100 ] }
        />

    );

};